export const OpenFolder = (props: React.SVGAttributes<SVGSVGElement>) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <mask
      id='mask0_11825_288876'
      mask-type='alpha'
      maskUnits='userSpaceOnUse'
      x='1'
      y='3'
      width='18'
      height='14'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.125 6.375C3.125 5.61561 3.74061 5 4.5 5H6.83333C7.13084 5 7.42033 5.09649 7.65833 5.275L9.09167 6.35C9.54604 6.69078 10.0987 6.875 10.6667 6.875H14.25C14.9673 6.875 15.5562 7.42419 15.6194 8.125H6.44152C5.31164 8.125 4.30852 8.848 3.95123 9.9199L3.125 12.3986V6.375ZM5.27485 16.875H4.5C3.05025 16.875 1.875 15.6997 1.875 14.25V6.375C1.875 4.92525 3.05025 3.75 4.5 3.75H6.83333C7.40131 3.75 7.95396 3.93422 8.40833 4.275L9.84167 5.35C10.0797 5.52851 10.3692 5.625 10.6667 5.625H14.25C15.6997 5.625 16.875 6.80025 16.875 8.25V8.28181C18.1594 8.7485 18.9311 10.1831 18.4654 11.5801L17.2988 15.0801C16.9415 16.152 15.9384 16.875 14.8085 16.875H9.375H5.27485Z'
        fill='black'
      />
    </mask>
    <g mask='url(#mask0_11825_288876)'>
      <path d='M20 0H0V20H20V0Z' fill='white' fillOpacity='0.5' />
    </g>
  </svg>
)
